import { useDispatch, useSelector } from "react-redux";
import { downloadTradesSumBookExcel } from "../thunks/downloadReportExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useTradeSumBookExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.domestic.trades.downloadXlsFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadTradesSumBookExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
